import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import React from 'react'
import { TabButtonGroup } from 'src/Components/TabButton'
import { TabButtonOption } from 'src/Components/TabButton/TabButtonGroup'
import SettingsBox from 'src/Elements/Data/SettingsBox'

interface Props {
  title: string
  actions: TabButtonOption[]
  activeIndex?: number
  description?: string | React.ReactElement
  name: string
  disabled?: boolean
  tooltipKey?: string
  depth?: number
}

/**
 * This component renders a settings box with button group.
 * Toggle has n options. Component should only be used with n >= 3, otherwise use SingleToggleSettingsBox.
 */
const MultipleToggleSettingBox: React.VFC<Props> = ({
  title,
  name,
  activeIndex = 0,
  disabled = false,
  actions,
  tooltipKey = '',
  depth = 0,
  ...rest
}) => {
  const actionButtons = (
    <OptionalTooltipWrapper titleKey={tooltipKey} hasTooltip={disabled}>
      <TabButtonGroup disabled={disabled} active={activeIndex} options={actions} />
    </OptionalTooltipWrapper>
  )
  return <SettingsBox title={title} suffix={actionButtons} {...rest} disabled={disabled} depth={depth} />
}

export default MultipleToggleSettingBox
